import { combineReducers } from "redux";
import auth from "./auth";
import alert from "./alert";
import page from "./page";

export default combineReducers({
  auth,
  alert,
  page
});
